module.exports = "/_next/static/images/e234598db73a1c4060ee17ec43321f84-hero-xs.jpg.webp";